export class EventEmitter {
  observers: any;

  constructor() {
    this.observers = {};
  }

  on(events: string, listener: Function) {
    var _this = this;

    events.split(' ').forEach(function (event) {
      _this.observers[event] = _this.observers[event] || [];

      _this.observers[event].push(listener);
    });
    return this;
  }

  off(event: string, listener?: Function) {
    if (!this.observers[event]) return;

    if (!listener) {
      delete this.observers[event];
      return;
    }

    this.observers[event] = this.observers[event].filter(function (l: Function) {
      return l !== listener;
    });
  }
  emit(event: string, _data?: any) {
    for (
      var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1;
      _key < _len;
      _key++
    ) {
      args[_key - 1] = arguments[_key];
    }

    if (this.observers[event]) {
      var cloned = [].concat(this.observers[event]);
      cloned.forEach(function (observer: Function) {
        observer.apply(void 0, args);
      });
    }

    if (this.observers['*']) {
      var _cloned = [].concat(this.observers['*']);

      _cloned.forEach(function (observer: Function) {
        observer.apply(observer, [event].concat(args));
      });
    }
  }
}
